<script setup>
    const props = defineProps({
        level: {
            type: String,
            required: true,
        },
        sponsors: {
            type: Array,
            required: true,
        },
    });

    const cleanSponsors = computed(() => {
        // A sponsor needs a logo to render. The link is optional — render
        // the card even when there's no website URL set in Bizzabo (it just
        // won't be clickable).
        const filteredSponsors = props.sponsors.filter((sponsor) => sponsor.sponsor_logo?.length);
        const sortedSponsors = filteredSponsors.sort((a, b) => {
            if (a.order && b.order) {
                return a.order - b.order;
            } else if (a.order) {
                return -1;
            } else if (b.order) {
                return 1;
            } else {
                return a.name.localeCompare(b.name);
            }
        });
        return sortedSponsors;
    });
</script>
<template>
    <div :id="level.toLowerCase()" class="sponsor-item">
        <!-- {{ cleanSponsors }} -->
        <MessHtml :html="level.replaceAll('_', ' ')" tag="h3" class="title" />
        <div class="sponsors-list flex flex-wrap justify-start gap-(--gap) mt-8" :data-level="level.toLowerCase()">
            <FragmentsSponsorsListSponsor v-for="(sponsor, index) in cleanSponsors" :sponsor="sponsor" :key="sponsor.id + '-list-item'" :style="`--index:${index % 5};`" />
        </div>
    </div>
</template>

<style>
    .sponsor-item .title {
        margin-top: 2.5rem;
        font-family: var(--font-hubspot-serif);
        font-size: calc(28 / var(--base-fs) * 1rem);
        line-height: 1.2;
        font-weight: 400;
        text-transform: capitalize;
        color: var(--magenta);
    }

    @media (min-width: 1024px) {
        .sponsor-item .title {
            margin-top: 60px;
            font-size: calc(40 / var(--base-fs) * 1rem);
        }
    }

    .sponsor-item .sponsors-list {
        --gap: 0.875rem;
        --items: 5;
        --spaces-between-items: calc(var(--items) - 1);
        --width: calc(100% / var(--items));
        --forced-width: calc(var(--width) - (var(--gap) * var(--spaces-between-items) / var(--items)));
    }

    .sponsor-item .sponsors-list[data-level='premiere'] {
        --items: 4;
    }

    .sponsor-item .sponsors-list .sponsor {
        width: var(--forced-width);
        position: relative;
    }

    @media (max-width: 1024px) {
        .sponsor-item .sponsors-list {
            --items: 2;
        }

        .sponsor-item .sponsors-list[data-level='premiere'] {
            --items: 1;
        }
    }
</style>
